import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import * as S from './CatalogGoodInfo.styled'
import GoodDescription from './GoodDescription/GoodDescription'
import GoodPriceAndChanger from './GoodPriceAndChanger/GoodPriceAndChanger'
import BasketGoodPriceAndChanger from './BasketGoodPriceAndChanger/BasketGoodPriceAndChanger'
import { useShipment } from '@entities/shipment/model'
import dynamic from 'next/dynamic'

// eslint-disable-next-line react/prop-types
// noinspection JSCheckFunctionSignatures
const AnaloguesPage = dynamic(() => import('@mobilePages/catalog/GoodPageMobile/AnaloguesPage/AnaloguesPage'), {
    ssr: false
})
// eslint-disable-next-line react/prop-types
const CatalogGoodInfo = ({ children, linkGoodCart, isRequiredNormalPrice }) => {
    const router = useRouter()
    const [isAnaloguesPage, setIsAnaloguesPage] = useState(false)
    const shipment = useShipment()
    const toggleAnaloguesPage = () => {
        setIsAnaloguesPage(!isAnaloguesPage)
    }
    const isFixPriceUrl =
        router.asPath.includes('/account/order') ||
        router.asPath.includes('/order/pickup/success') ||
        router.asPath.includes('/order/delivery/success')

    const isShowedFixPrice = !isRequiredNormalPrice && isFixPriceUrl
    return (
        <S.Container>
            <GoodDescription
                linkGoodCart={linkGoodCart}
                name={children.webData.drugTitle}
                description={children.webData.outFormTitle}
                maker={children.webData.makerTitle}
            />
            {router.asPath.includes('/order/basket') ? (
                <BasketGoodPriceAndChanger
                    good={children}
                    shipment={shipment}
                    toggleAnaloguesPage={toggleAnaloguesPage}
                />
            ) : (
                <GoodPriceAndChanger
                    isShowedFixPrice={isShowedFixPrice}
                    good={children}
                    shipment={shipment}
                    toggleAnaloguesPage={toggleAnaloguesPage}
                />
            )}
            {isAnaloguesPage && (
                <AnaloguesPage
                    closeHandler={() => setIsAnaloguesPage(!isAnaloguesPage)}
                    goodId={children.webData.goodId}
                    shipment={shipment}
                />
            )}
        </S.Container>
    )
}

CatalogGoodInfo.propTypes = {
    children: PropTypes.any.isRequired,
    isRequiredNormalPrice: PropTypes.bool.isRequired
}

CatalogGoodInfo.defaultProps = {
    isRequiredNormalPrice: false
}

export default CatalogGoodInfo
